import { React, lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
// import Loading from "./Loading/Loading";
import PageLoading from "./Loading/PageLoading";
import Olympiad from "../pages/Olympiad";

const Home = lazy(() => import("../pages/Home"));
const News = lazy(() => import("../pages/News"));
const Gorelde = lazy(() => import("../pages/Gorelde"));
const Talyp = lazy(() => import("../pages/Talyp"));
const Graduates = lazy(() => import("../pages/Graduates"));
const Faculties = lazy(() => import("../pages/Faculties"));
const ProductCenter = lazy(() => import("../pages/ProductCenter"));
const Major = lazy(() => import("../pages/Major"));
const AboutUs = lazy(() => import("../pages/AboutUs"));
const Frame = lazy(() => import("../pages/Frame"));
const RearchPublic = lazy(() => import("../pages/RearchPublic"));
const CursCenter = lazy(() => import("../pages/CursCenter"));
const NewsOpen = lazy(() => import("../pages/NewsOpen"));
const ResearchOpen = lazy(() => import("../pages/ResearchOpen"));
const MajorView = lazy(() => import("../pages/MajorView"));
const CampusView = lazy(() => import("../pages/Campus/index"));
const ExemplaryStudents = lazy(() => import("../pages/ExemplaryStudents"));
const ProductOpen = lazy(() => import("../pages/ProductOpen"));

const SustainabilityHome = lazy(() => import("../sustanabilty/Home"));
const SustainabilityProject = lazy(() => import("../sustanabilty/Project"));
const SustainabilityPolicies = lazy(() => import("../sustanabilty/Policies"));
const Competitions = lazy(() => import("../pages/Competitions"));
const CompetitionSubmit = lazy(() => import("../pages/CompetitionSubmit"));

const SideBarNavbar = lazy(() => import("./SidebarNavbar"));

function Router() {
  let routes = useRoutes([
    {
      element: (
        <Suspense fallback={<PageLoading />}>
          <SideBarNavbar />
        </Suspense>
      ),
      children: [
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <Home />
            </Suspense>
          ),
          path: "/",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <News />
            </Suspense>
          ),
          path: "/news",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <Olympiad />
            </Suspense>
          ),
          path: "/olympiad",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <Competitions />
            </Suspense>
          ),
          path: "/competitions/:id",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <CompetitionSubmit />
            </Suspense>
          ),
          path: "/competitions/:id/submit",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <NewsOpen />
            </Suspense>
          ),
          path: "/news/:newsId",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <Gorelde />
            </Suspense>
          ),
          path: "/gorelde",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <Talyp />
            </Suspense>
          ),
          path: "/talyp",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <Graduates />
            </Suspense>
          ),
          path: "/graduates",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <Faculties />
            </Suspense>
          ),
          path: "/faculty",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <Major />
            </Suspense>
          ),
          path: "/major/:facultyId",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <ProductOpen />
            </Suspense>
          ),
          path: "/productOpen/:productId",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <AboutUs />
            </Suspense>
          ),
          path: "/about-us",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <ProductCenter />
            </Suspense>
          ),
          path: "/product-center",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <Frame />
            </Suspense>
          ),
          path: "/frame",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <RearchPublic />
            </Suspense>
          ),
          path: "/Rearch_Public",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <ResearchOpen />
            </Suspense>
          ),
          path: "/research/:researchId",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <CursCenter />
            </Suspense>
          ),
          path: "/curs-center",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <MajorView />
            </Suspense>
          ),
          path: "/major_view/:majorID",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <CampusView />
            </Suspense>
          ),
          path: "/student-life",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <CampusView />
            </Suspense>
          ),
          path: "/sport-club",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <CampusView />
            </Suspense>
          ),
          path: "/museum",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <CampusView />
            </Suspense>
          ),
          path: "/i-club",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <CampusView />
            </Suspense>
          ),
          path: "/dormitary",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <CampusView />
            </Suspense>
          ),
          path: "/library",
        },
        {
          element: (
            <Suspense fallback={<PageLoading />}>
              <ExemplaryStudents />
            </Suspense>
          ),
          path: "/exemplary-students",
        },
      ],
    },
    {
      element: (
        <Suspense fallback={<PageLoading />}>
          <SustainabilityHome />
        </Suspense>
      ),
      path: "/sustainability/",
    },
    {
      element: (
        <Suspense fallback={<PageLoading />}>
          <SustainabilityProject />
        </Suspense>
      ),
      path: "/sustainability/project/:id",
    },
    {
      element: (
        <Suspense fallback={<PageLoading />}>
          <SustainabilityPolicies />
        </Suspense>
      ),
      path: "/sustainability/policies",
    },
    {
      element: <Navigate to="/" />,
      path: "*",
    },
  ]);
  return routes;
}

export default Router;
